import produce from 'immer';
import create from 'zustand';

const useContributorStore = create(set => ({
  toChange: false,
  prev: null, // slug
  dft: null, // slug
  set: fn => set(produce(fn)),
}));

export default useContributorStore;
